"use client";

import { Button } from "@/components/ui/button";

export default function NotFound() {

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <p className="text-2xl mt-4">Oops! Page not found.</p>
        <p className="mt-4 text-muted-foreground"> <em>Amir probably messed up something.</em> </p>
        <Button onClick={() => window.history.back()} className="mt-8">
          Go Back
        </Button>
      </div>
    </div>
  );
}
